import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, ArrowDown } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-wc-blue text-white overflow-hidden pt-12 pb-12 lg:pt-16 lg:pb-16 min-h-screen flex items-center" data-id="element-142">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10" data-id="element-143">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMiIgY3k9IjIiIHI9IjIiIGZpbGw9IiNmZmZmZmYiLz48L3N2Zz4=')] bg-repeat opacity-20" data-id="element-144"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10 w-full" data-id="element-145">
        <div className="max-w-3xl mx-auto text-center flex flex-col items-center" data-id="element-146">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-147">
            <div className="inline-block bg-wc-yellow text-wc-dark font-bold px-3 py-1 rounded-full text-xs mb-3 uppercase tracking-wider" data-id="element-148">
              🏆 Megapack Álbum Mundial 2026
            </div>

            <h1 className="text-3xl sm:text-4xl lg:text-5xl leading-tight mb-4 text-white drop-shadow-lg font-[700]" data-id="element-149">
              Completá el álbum del Mundial HOY{' '}
              <span className="text-wc-yellow font-[700]" data-id="element-150">
                sin gastar una fortuna en sobres
              </span>
            </h1>
          </motion.div>

          <motion.div className="relative w-full max-w-[240px] sm:max-w-[280px] mb-4" initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5,
          delay: 0.15
        }} data-id="element-151">
            <div className="absolute inset-0 bg-wc-yellow rounded-full blur-3xl opacity-20 animate-pulse" data-id="element-152"></div>

            <img src="https://cdn.magicpatterns.com/uploads/aVKH1hXYW3qhyndYou829G/Diseno_sin_titulo_(16).png" alt="Mockup Álbum Mundial 2026" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-153" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="w-full" data-id="element-154">
            <p className="sm:text-lg lg:text-xl mb-6 text-blue-100 max-w-2xl mx-auto font-[700] text-[16px]" data-id="element-155">
              Descarga el álbum completo y todas las figuritas, LISTO para
              imprimir en casa o en cualquier librería y viví la emoción del
              Mundial sin repetidas, sin faltantes.
            </p>

            <a href="#pricing" className="inline-flex items-center justify-center gap-3 bg-wc-red hover:bg-red-700 text-white font-bold py-4 px-8 rounded-xl text-lg lg:text-xl transition-transform transform hover:scale-105 shadow-2xl mb-5" data-id="element-156">
              QUIERO COMPLETAR MI AL ÁLBUM
            </a>

            <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs sm:text-sm text-blue-200" data-id="element-157">
              <div className="flex items-center gap-1.5" data-id="element-158">
                <CheckCircle size={16} className="text-wc-yellow" data-id="element-159" />
                <span data-id="element-160">Pago 100% seguro</span>
              </div>
              <div className="flex items-center gap-1.5 text-wc-yellow font-bold" data-id="element-161">
                <span data-id="element-162">🎁 El álbum te lo regalamos nosotros 🎁</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-163">
                <CheckCircle size={16} className="text-wc-yellow" data-id="element-164" />
                <span data-id="element-165">Alta Resolución</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-166">
                <CheckCircle size={16} className="text-wc-yellow" data-id="element-167" />
                <span data-id="element-168">Acceso Inmediato</span>
              </div>
              <div className="flex items-center gap-1.5 text-wc-yellow font-bold" data-id="element-169"></div>
              <div className="flex items-center gap-1.5" data-id="element-170">
                
              </div>
              <div className="flex items-center gap-1.5" data-id="element-171">
                
                
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}